import PageHeader from './PageHeader'
import { DeniedState } from './States'
import { useSession } from '../lib/sessionContext'

/**
 * A screen for one role, decided from the session before the screen loads anything.
 *
 * The screens found out from their first call instead, each in its own way — an error
 * pop-up over its own action buttons, counters that spin for ever, a generic "رسالة الخطأ".
 * The session already carries the roles, so the answer comes first.
 *
 * @param {string} role   the role the slice's endpoints require
 * @param {string} title  the screen's own title, above the denied state
 */
export default function RoleGate({ role, title, children }) {
  const { session } = useSession()
  if ((session?.roles ?? []).includes(role)) return children

  return (
    <>
      <PageHeader title={title} />
      <DeniedState />
    </>
  )
}
